import { IFormOptions } from './IFormOptions.interface';

export interface IFormDelegate {
    onSubmit(result: any, formOptions?: IFormOptions): void;
}
